import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-transaction-type-other",
  // imports: [],
  templateUrl: "./transaction-type-other.component.html",
  styleUrl: "./transaction-type-other.component.css",
  standalone: false,
})
export class TransactionTypeOtherComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {
    // if (changes["isActive"] && changes["isActive"].currentValue === true) {
    //   // your logic to fetch unprocessed issuer data
    // }
  }
}
